package org.gymly.navigation

import kotlinx.browser.window

actual fun pushWebHash(hash: String, replace: Boolean) {
    val normalized = if (hash.startsWith("#")) hash else "#$hash"
    val newUrl = window.location.pathname + window.location.search + normalized
    val current = window.location.pathname + window.location.search + window.location.hash
    if (current == newUrl) return
    if (replace) {
        window.history.replaceState(null, "", newUrl)
    } else {
        window.history.pushState(null, "", newUrl)
    }
}

actual fun currentWebHash(): String = window.location.hash.ifEmpty { "#/" }

actual fun currentWebPageUrl(): String = window.location.origin + window.location.pathname

actual fun installWebHashListener(onChange: () -> Unit): () -> Unit {
    val handler: (dynamic) -> Unit = { onChange() }
    window.addEventListener("popstate", handler)
    window.addEventListener("hashchange", handler)
    return {
        window.removeEventListener("popstate", handler)
        window.removeEventListener("hashchange", handler)
    }
}
